import React, { FC } from 'react';
import { TokensPair } from '@app/components/TokensPair';
import { Grid, HStack, Text } from '@chakra-ui/react';
import { formatWalletAddress } from '@app/helpers/format';
import { CopyButton } from '@app/components/CopyButton';

interface Props {
  token0Symbol: string;
  token1Symbol: string;
  address: string;
}

export const TokensTitle: FC<Props> = ({
  token0Symbol,
  token1Symbol,
  address
}) => {
  return (
    <Grid
      gridTemplateColumns="64px 1fr 24px"
      gridColumnGap="8px"
      gridRowGap={0}
      alignItems="center"
      w="100%"
      gridTemplateAreas="'icon source details' 'icon symbol details'"
      py="12px"
      px="12px"
    >
      <TokensPair
        token0Symbol={token0Symbol}
        token1Symbol={token1Symbol}
        gridArea="icon"
      />
      <Text
        fontSize="16px"
        lineHeight="21px"
        fontWeight={500}
        color="neutral.100"
        textTransform="capitalize"
        gridArea="source"
        textAlign="left"
      >
        {token0Symbol} - {token1Symbol}
      </Text>
      <HStack gridArea="symbol">
        <Text
          fontSize="14px"
          color="neutral.400"
          textTransform="capitalize"
          textAlign="left"
          _hover={{ color: 'neutral.100' }}
        >
          {formatWalletAddress(address)}
        </Text>
        <CopyButton text={address ?? ''} />
      </HStack>
    </Grid>
  );
};
